import axios from 'axios';

const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '0.0.0.0']);

const resolveApiBaseUrl = () => {
  const envUrl = process.env.REACT_APP_API_URL?.trim();
  console.log('Resolved API Base URL:', envUrl);
  if (typeof window === 'undefined') {
    return envUrl || 'http://localhost:8000';
  }

  if (!envUrl) {
    return `http://${window.location.hostname}:8000`;
  }

  try {
    const parsed = new URL(envUrl);
    if (!LOCAL_HOSTS.has(parsed.hostname) || LOCAL_HOSTS.has(window.location.hostname)) {
      return parsed.toString().replace(/\/$/, '');
    }

    parsed.hostname = window.location.hostname;
    return parsed.toString().replace(/\/$/, '');
  } catch {
    return envUrl.replace(/\/$/, '');
  }
};

const api = axios.create({
  baseURL: resolveApiBaseUrl(),
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
